import {
  PlatformLookupCnpjParamsSchema,
  PlatformLookupCnpjResponseSchema,
} from '@zrsystem/contracts';

import { platformHttp } from '@/features/platform/api/platform-http.js';

export async function lookupPlatformCnpj(cnpj: string) {
  const parsed = PlatformLookupCnpjParamsSchema.parse({ cnpj: cnpj.replace(/\D/g, '') });
  const raw = await platformHttp.get<unknown>(`/geo/lookup-cnpj/${parsed.cnpj}`);
  return PlatformLookupCnpjResponseSchema.parse(raw);
}
